/**
 * Auth Flow Rule — login/signup blocks must have proper auth flows.
 */

import type { FeatureRule, RuleViolation, BlockData } from "../types"

function jsonStr(obj: unknown): string {
  return JSON.stringify(obj ?? {})
}

export const authFlowRule: FeatureRule = {
  id: "auth-flow",
  name: "Authentication Flow",
  detect: (data) => {
    const uiStr = jsonStr(data.ui)
    const flowStr = jsonStr(data.flow)
    return /login|sign.?in|sign.?up|auth/i.test(uiStr + flowStr)
  },
  check: (data) => {
    const violations: RuleViolation[] = []
    const flowStr = jsonStr(data.flow)
    const uiStr = jsonStr(data.ui)

    // Must have password input
    if (/login|sign.?in/i.test(uiStr) && !uiStr.includes("password")) {
      violations.push({
        rule: "auth-no-password",
        level: "warning",
        message: "Login UI has no password field.",
      })
    }

    // Must have API call for auth
    if (/login|sign.?in/i.test(flowStr) && !flowStr.includes("restApi") && !flowStr.includes("supabase")) {
      violations.push({
        rule: "auth-no-api",
        level: "error",
        message: "Auth flow has no API call (restApi/supabase). Login requires server validation.",
      })
    }

    // Should set user state after login
    if (/login|sign.?in/i.test(flowStr) && !flowStr.includes("user")) {
      violations.push({
        rule: "auth-no-user-state",
        level: "warning",
        message: "Auth flow does not set user state after login.",
      })
    }

    return violations
  },
}
